import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthService } from "./auth.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class GalleryService {
  baseUrl = environment.baseUrl;
  constructor(private http: HttpClient, private auth: AuthService) {}

  getPMgallery() {
    let headers = new HttpHeaders();
    headers = headers.set("content-type", "application/json");
    return this.http.get(`${this.baseUrl}v1/gallery/pmshri/`, { headers });
  }
}
